(function () {
  const DATA_LAYER_NAME = 'dataLayer';
  const CHECKOUT_SOURCE = '1checkout';
  let lastOneCheckoutItem = null;

  function getDataLayer() {
    window[DATA_LAYER_NAME] = window[DATA_LAYER_NAME] || [];
    return window[DATA_LAYER_NAME];
  }

  function pushEvent(payload) {
    getDataLayer().push(payload);
  }

  function pushEcommerceEvent(eventName, ecommerce, metadata) {
    pushEvent({ ecommerce: null });
    pushEvent({
      event: eventName,
      ecommerce,
      ...metadata,
    });
  }

  function parseInteger(value, fallback) {
    const parsed = parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function moneyFromCents(value) {
    const cents = parseInteger(value, 0);
    return cents / 100;
  }

  function getQuantity(value) {
    const quantity = parseInteger(value, 1);
    return quantity > 0 ? quantity : 1;
  }

  function getProductTitle() {
    const title =
      document.querySelector('.product__title h1') ||
      document.querySelector('.sticky_info_wrapper h4') ||
      document.querySelector('h1');

    return title ? title.textContent.trim() : undefined;
  }

  function getProductFormFromTarget(target) {
    if (!(target instanceof Element)) return null;
    return target.closest('form[action*="/cart/add"], form[data-type="add-to-cart-form"]');
  }

  function getSelectedVariantId(form) {
    return form?.querySelector('[name="id"]')?.value || undefined;
  }

  function getSelectedQuantity(form) {
    return getQuantity(form?.querySelector('[name="quantity"]')?.value);
  }

  function buildItemFromCartLine(line) {
    if (!line) return null;

    const quantity = getQuantity(line.quantity);
    const price = moneyFromCents(line.final_price || line.price);

    return {
      item_id: String(line.sku || line.variant_id || line.id || ''),
      item_name: line.product_title || line.title || line.product_type || 'Product',
      item_variant: line.variant_title || undefined,
      item_brand: line.vendor || undefined,
      item_category: line.product_type || undefined,
      price,
      quantity,
    };
  }

  function buildFallbackItem(form, detail) {
    const variantId = detail?.variant || detail?.productVariantId || getSelectedVariantId(form);
    const quantity = getQuantity(detail?.quantity || getSelectedQuantity(form));

    return {
      item_id: variantId ? String(variantId) : undefined,
      item_name: getProductTitle() || 'Product',
      quantity,
    };
  }

  function trackShopifyAddToCart(event) {
    if (!event || event.source !== 'product-form') return;

    const item = buildItemFromCartLine(event.cartData);
    if (!item) return;

    const value = Number((item.price * item.quantity).toFixed(2));

    pushEcommerceEvent(
      'add_to_cart',
      {
        currency: event.cartData.currency || window.Shopify?.currency?.active || 'INR',
        value,
        items: [item],
      },
      {
        cart_source: 'shopify_product_form',
        product_variant_id: event.productVariantId ? String(event.productVariantId) : item.item_id,
      }
    );
  }

  function trackBuyNowClick(event) {
    const button = event.target instanceof Element ? event.target.closest('#buyNow1CheckoutBtn') : null;
    if (!button) return;

    const form = getProductFormFromTarget(button);
    const item = buildFallbackItem(form);
    lastOneCheckoutItem = item;

    pushEcommerceEvent(
      'buy_now_click',
      {
        currency: window.Shopify?.currency?.active || 'INR',
        items: [item],
      },
      {
        checkout_source: CHECKOUT_SOURCE,
        product_variant_id: item.item_id,
        page_location: window.location.href,
      }
    );
  }

  function trackOneCheckoutBeginCheckout(event) {
    const form = getProductFormFromTarget(document.activeElement);
    const item = lastOneCheckoutItem || buildFallbackItem(form, event.detail);
    lastOneCheckoutItem = null;

    pushEcommerceEvent(
      'begin_checkout',
      {
        currency: window.Shopify?.currency?.active || 'INR',
        items: [item],
      },
      {
        checkout_source: CHECKOUT_SOURCE,
        product_variant_id: item.item_id,
        page_location: window.location.href,
      }
    );
  }

  function init() {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, trackShopifyAddToCart);
    }

    document.addEventListener('click', trackBuyNowClick, true);
    document.documentElement.addEventListener('product:added', trackOneCheckoutBeginCheckout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
